import { v4 as uuidv4 } from 'uuid'
import { OpalApiComponent } from '../../schema'

type UserGroup = OpalApiComponent<'V3', 'user_group'>

type Attributes = {
  name: string
  description?: string
  memberIds?: Array<string>
  assetId?: string
}

const defaultAttributes: Omit<
  OpalApiComponent<'V3', 'user_group'>['attributes'],
  'name' | 'description'
> = {
  is_archived: false,
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
}

export const resourceObject = ({
  name,
  description,
  memberIds = [],
  assetId,
}: Attributes): UserGroup => ({
  id: uuidv4(),
  type: 'user_group',
  attributes: {
    name,
    description,
    ...defaultAttributes,
  },
  relationships: {
    members: {
      data: memberIds?.map((id) => ({
        id,
        type: 'user',
      })),
    },
    asset: {
      data: assetId
        ? {
            id: assetId,
            type: 'asset',
          }
        : null,
    },
    created_by_user: {
      data: {
        id: uuidv4(),
        type: 'user',
      },
    },
    inherited_groups: { data: [] },
  },
})
